import React, { useState, useEffect } from 'react';
import { v4 as uuid } from 'uuid';
import { db } from './Firebase/firebase';

import './form.css';
// Assets
import logo from './assets/usku_logo.png';
import loading_gif from './assets/loading.gif';

import PlacesAutocomplete from 'react-places-autocomplete';
import FlashMessage from 'react-flash-message';
import { Redirect } from 'react-router-dom';

const BusinessForm = (props) => {
    // const [endpoint] = useState("http://localhost:3001");
    // const [response, setResponse] = useState("");

    const [name, setName] = useState("");
    const [deliveryAddress, setDeliveryAddress] = useState("");
    const [phone, setPhone] = useState("");
    const [item, setItem] = useState("");
    const [deliveryClass, setDeliveryClass] = useState("normal");
    const [surchargeFee, setSurchargeFee] = useState("");
    const [upfrontFee, setUpfrontFee] = useState("");
    const [prePurchase, setPrePurchase] = useState(true);
    const [cost, setCost] = useState("");
    const [numberOfItems, setNumberOfItems] = useState("");
    const [pickupName, setPickupName] = useState("");
    const [pickupAddress, setPickupAddress] = useState("");
    const [details, setDetails] = useState("");
    const [pickupInstruction, setPickupInstruction] = useState("")
    const [formPage, setFormPage] = useState(true);
    const [orderPin, setOrderPin] = useState("");
    const [termsAccepted, setTermsAccepted] = useState(false);
    const [payerName, setPayerName] = useState("");
    const [payerPhone, setPayerPhone] = useState("");

    const [fee, setFee] = useState("");

    const [businessCode, setBusinessCode] = useState(null);
    const [businessInfo, setBusinessInfo] = useState(null);
    const [email, setEmail] = useState("");
    const [deliveryTime, setDeliveryTime] = useState("13:00");
    const [deliveryDate, setDeliveryDate] = useState("");

    const [prePurchaseSelected, setPrePurchaseSelected] = useState(true);

    const [loading, setLoading] = useState(false);
    const [submitted, setSubmitted] = useState(false);

    const [minDate, setMinDate] = useState("");
    const [formPrefilled, setformPrefilled] = useState(false);

    useEffect(() => {
        setOrderPin(uuid());
        setMinDate(getCurrentDate());
        setBusinessCode(parseParams(props.location.search).code);

        if (businessInfo) {

        }
    }, [])
    
    const getBusinessInfo = () => {
        try {
            db.collection('business_code').doc(businessCode)
                .get()
                .then((doc) => {
                    if (doc.exists) {
                        let email = doc.data().email;
                        db.collection('business').doc(email)
                            .get()
                            .then((doc) => {
                                if (doc.exists) {
                                    let temp = doc.data();
                                    temp['email'] = email;
                                    setBusinessInfo(temp);
                                }
                            })
                    }
                })
        } catch (e) {
            console.log(e.message);
        }
    }

    const getCurrentDate = () => {
        const d = new Date();
        return d.toISOString().substr(0, 10);
    }

    const sendOrder = (e) => {
        e.preventDefault();
        setSubmitted(true);
        console.log("Pre purchase selected");
        // console.log("Number of items" + numberOfItems);
        if (!name || !deliveryAddress || !deliveryTime || !deliveryDate || !phone || !payerName || !payerPhone || !item || (!cost && !prePurchase && !numberOfItems)
            || !prePurchaseSelected || !pickupName || !pickupAddress || !details || !termsAccepted)
        {
            console.log("missing field");
            return;
        }
        else {
            setLoading(true);
            setTimeout(() => {
                setLoading(false);
                setFormPage(false);

            }, 3000)
            const message = formatMessage();
            console.log(message);

            fetch('https://usku-delivery-server.herokuapp.com/processEnterprise', {
                method: 'POST',
                headers: {'Content-Type': 'application/json'},
                body: JSON.stringify({
                    orderPin,
                    name,
                    deliveryAddress,
                    deliveryDate,
                    deliveryTime,
                    phone,
                    item,
                    deliveryClass,
                    prePurchase,
                    cost,
                    numberOfItems,
                    pickupName,
                    pickupAddress,
                    details,
                    pickupInstruction,
                    email,
                    payerName,
                    payerPhone,
                    termsAccepted
                })
            })
            .then((response) => response.json())
            .then((data) => {
              console.log('Success:', data);
            })
            .catch(err => console.log("Error: ", err))
        }
    }

    const calculateFee = (e, origin, destination) => {
        e.preventDefault();
        if (!deliveryAddress || !pickupAddress) {
            console.log("missing field");
            return;
        } else {
            setFee(" Calculating...");
            deliveryClass === 'extra' ? setSurchargeFee(9) : setSurchargeFee(0);
            if (!prePurchase && numberOfItems !== "") {
                try {
                    setUpfrontFee(numberOfItems * 0.45);
                } catch (error) {
                    setUpfrontFee("Error in calculating");
                }
            } else if (prePurchase) {
                setUpfrontFee(0);
            }

            const torigin = origin.replace('&', '');
            const tdestination = destination.replace('&', '');

            const url = `https://usku-delivery-server.herokuapp.com/get_distance?origin=${torigin}&destination=${tdestination}`;
            fetch(url, {
                method: 'GET',
                headers: {'Content-Type': 'application/json'}}
            )
            .then((response) => {
                if (response.ok) {
                    return response.json();
                } else {
                    setFee(" Unable to calculate the distance.");
                    throw new Error();
                }
            })
            .then(data => {
                if (data.distance <= 3000) {
                    const temporaryFee = 5;
                    setFee(temporaryFee);
                } else {
                    let temporaryFee = 0.9 * ((data.distance/1000) - 3) + 5;
                    temporaryFee = parseFloat((temporaryFee).toFixed(2));
                    setFee(temporaryFee);
                }
                console.log(data.distance);
            })
            .catch(err => {
                console.log("Error in calculating the distance. Please make sure both location are geographically correct");
                console.log(err);
            });
        }
    }

    const formatMessage = () => {
        let message = `
            *PIN*
            ${orderPin}\n
            *name:*
            ${name}\n
            *Delivery Address:*
            ${deliveryAddress}\n
            *Delivery Date and Time:*
            ${deliveryTime}\n
            *Phone:*
            ${phone}\n
            *Email Address*
            ${email}\n
            *Payer Name*
            ${payerName}\n
            *Payer Phone*
            ${payerPhone}\n
            *Item(s):*
            ${item}\n
            *Service Charge:*
            ${deliveryClass}\n
            *Number of Items:*
            ${numberOfItems}\n
            *Pre Purchased:*
            ${prePurchase}\n
            *Estimated Cost:*
            ${cost}\n
            *Location / Store Name:*
            ${pickupName}\n
            *Pickup Address:*
            ${pickupAddress}\n
            *Delivery Instructions:*
            ${details}\n
            *Pickup Instructions:*
            ${pickupInstruction}\n
            `

        return message.replace(/ /g,'');
        ;
    }

    const parseParams = (params = "") => {
        const rawParams = params.replace("?", "").split("&");
        const extractedParams = {};
        rawParams.forEach((item) => {
          item = item.split("=");
          extractedParams[item[0]] = item[1];
        });
        return extractedParams;
    };
      

    if (formPage) {
        if (businessCode && businessInfo === null) {
            console.log("Retrieving business info")
            getBusinessInfo();
        }

        if (businessInfo && !formPrefilled) {
            if (businessInfo.status === "active") {
                console.log("prefilling form..")
                let tempAddress = businessInfo.no + " " + businessInfo.street + ", " + businessInfo.city + ", VIC " + businessInfo.postcode + ", Australia"
                setPickupName(businessInfo.businessName);
                setPickupAddress(tempAddress);
                setformPrefilled(true);
            } else {
                // inactive business
                console.log("account not active...Redirecting")
                return <Redirect to={{ pathname: '/' }} />;
            }
        }

        // const flashMsg = "Please use the Chrome browser for the best and guaranteed experience";
        const flashMsg = "Due to high traffic during festive season, please set the pickup/drop-off time accordingly prior to traffic conditions as it might longer";

        return (
            <form className="form">
                <FlashMessage duration={5000} persistOnHover={true}>
                    <p style={{ display: "block", width: "100vw", backgroundColor: "#FFCCCB", paddingTop: "8px", paddingBottom: "8px", fontSize: "20px" }}>{flashMsg}</p>
                </FlashMessage>
                <img className="usku-logo-left" src={logo} alt="Usku" />
                <div className="form-container">
                    <h1>Place Your Order</h1>
                    <p>You will hear from us shortly after placing your order</p>
                    <div className="input-container">
                        <label className={(!name && submitted) ? 'red' : ''}>Recipient Name</label>
                        <input onChange={(e) => setName(e.target.value)} type="text" value={name} placeholder="The person receiving this delivery" />
                    </div>
                    <div className="input-container">
                        <label className={(!phone && submitted) ? 'red' : ''}>Recipient Phone</label>
                        <input onChange={(e) => setPhone(e.target.value)} type="text" value={phone} placeholder="0412 345 678" />
                    </div>
                    <div className="input-container">
                        <label className={(!deliveryAddress && submitted) ? 'red' : ''}>Delivery Address</label>
                        <PlacesAutocomplete
                            value={deliveryAddress}
                            onChange={(e) => {setDeliveryAddress(e)}}
                            onSelect={(e) => {setDeliveryAddress(e)}}>
                            {({ getInputProps, suggestions, getSuggestionItemProps, loading }) => (
                            <div>
                                <input
                                {...getInputProps({
                                    placeholder: '12 Example St, Box Hill 3128',
                                    className: 'location-search-input',
                                })}
                                />
                                <div className="autocomplete-dropdown-container">
                                {loading && <div>Loading...</div>}
                                {suggestions.map(suggestion => {
                                    const className = suggestion.active
                                    ? 'suggestion-item--active'
                                    : 'suggestion-item';
                                    // inline style for demonstration purpose
                                    const style = suggestion.active
                                    ? { backgroundColor: '#fafafa', cursor: 'pointer' }
                                    : { backgroundColor: '#ffffff', cursor: 'pointer' };
                                    return (
                                    <div
                                        {...getSuggestionItemProps(suggestion, {
                                        className,
                                        style,
                                        })}
                                    >
                                        <span>{suggestion.description}</span>
                                    </div>
                                    );
                                })}
                                </div>
                            </div>
                            )}
                        </PlacesAutocomplete>
                    </div>
                    <div className="input-container">
                        <label className={(!deliveryDate && submitted) ? 'red' : ''}>Pickup Date</label>
                        <input onChange={(e) => setDeliveryDate(e.target.value)} type="date" value={deliveryDate} min={minDate} placeholder="YYYY-MM-DD" required="required" />
                    </div>
                    <div className="input-container">
                        <label className={(!deliveryTime && submitted) ? 'red' : ''}>Pickup Time</label>
                        <input onChange={(e) => setDeliveryTime(e.target.value)} maxLength="5" placeholder="13:00" type="time" value={deliveryTime} />
                    </div>
                    <div className="input-container">
                        <label className={(!payerName && submitted) ? 'red' : ''}>Payer Name</label>
                        <input onChange={(e) => setPayerName(e.target.value)} type="text" value={payerName} placeholder="Payer Name" required="required" />
                    </div>
                    <div className="input-container">
                        <label className={(!payerPhone && submitted) ? 'red' : ''}>Payer Phone</label>
                        <input onChange={(e) => setPayerPhone(e.target.value)} type="text" value={payerPhone} placeholder="0404040404" required="required" />
                    </div>
                    <div className="input-container">
                        <label className={(!email && submitted) ? 'red' : ''}>Payer Email Address</label>
                        <input onChange={(e) => setEmail(e.target.value)} type="email" value={email} placeholder="example@example.com" required="required" />
                    </div>
                    <div className="input-container">
                        <label className={(!item && submitted) ? 'red' : ''}>What would you like delivered?</label>
                        <input onChange={(e) => setItem(e.target.value)} type="text" value={item} placeholder="" />
                    </div>
                    <div style={{margin: '10px 0'}} className="input-container">
                        <label className={(!deliveryClass && submitted) ? 'red' : ''} htmlFor="deliveryClass">Include multiple pickup/shopping/total weights over 10kg</label>
                        <select onChange={(e) => {setDeliveryClass(e.target.value)}} value={deliveryClass}  id="deliveryClass">
                            <option value="normal">No</option>
                            <option value="extra">Yes</option>
                        </select>
                    </div>
                    <div style={{margin: '10px 0'}} className="input-container">
                        <label className={(!prePurchaseSelected && submitted) ? 'red' : ''}>Do you need us to pay on your behalf?</label>
                        <input onClick={() => {setPrePurchase(false); setPrePurchaseSelected(true); console.log(prePurchase)}} type="radio" name="prePurchase" /> Yes
                        <input onClick={() => {setPrePurchase(true); setPrePurchaseSelected(true); console.log(prePurchase)}} type="radio" name="prePurchase" checked="checked" /> No
                    </div>
                    <div style={prePurchaseSelected && !prePurchase ? {display: 'block'} : {display: 'none'}} className="input-container" placeholder="25.40">
                        <label className={(!cost && !prePurchase && submitted) ? 'red' : ''}>What is the estimated price of product?</label>
                        <input onChange={(e) => setCost(e.target.value)}  type="number" step="0.01" value={cost} />
                    </div>
                    <div style={prePurchaseSelected && !prePurchase ? {display: 'block'} : {display: 'none'}} className="input-container" placeholder="4">
                        <label className={(!numberOfItems && !prePurchase && submitted) ? 'red' : ''}>Total Number of Items</label>
                        <input onChange={(e) => setNumberOfItems(e.target.value)} type="number" value={numberOfItems} />
                    </div>
                    <div className="input-container">
                        <label className={(!pickupName && submitted) ? 'red' : ''}>Location / Store Name</label>
                        <input onChange={(e) => setPickupName(e.target.value)} type="text" value={pickupName} placeholder="Bobs Bakery" />
                    </div>
                    <div className="input-container">
                        <label className={(!pickupAddress && submitted) ? 'red' : ''}>Pickup Address</label>
                        <PlacesAutocomplete
                            value={pickupAddress}
                            onChange={(e) => setPickupAddress(e)}
                            onSelect={(e) => setPickupAddress(e)}>
                            {({ getInputProps, suggestions, getSuggestionItemProps, loading }) => (
                            <div>
                                <input
                                {...getInputProps({
                                    placeholder: '44 Example St, Box Hill 3128',
                                    className: 'location-search-input',
                                })}
                                />
                                <div className="autocomplete-dropdown-container">
                                {loading && <div>Loading...</div>}
                                {suggestions.map(suggestion => {
                                    const className = suggestion.active
                                    ? 'suggestion-item--active'
                                    : 'suggestion-item';
                                    // inline style for demonstration purpose
                                    const style = suggestion.active
                                    ? { backgroundColor: '#fafafa', cursor: 'pointer' }
                                    : { backgroundColor: '#ffffff', cursor: 'pointer' };
                                    return (
                                    <div
                                        {...getSuggestionItemProps(suggestion, {
                                        className,
                                        style,
                                        })}
                                    >
                                        <span>{suggestion.description}</span>
                                    </div>
                                    );
                                })}
                                </div>
                            </div>
                            )}
                        </PlacesAutocomplete>
                    </div>
                    <div className="input-container">
                        <label className={(!details && submitted) ? 'red' : ''}>Delivery Instructions</label>
                        <textarea maxLength="200" onChange={(e) => setDetails(e.target.value)} type="text" value={details} placeholder="Deliver after 3pm today. Please leave behind side gate if no one home." />
                    </div>
                    <div className="input-container">
                        <label className={(!pickupInstruction && submitted) ? 'red' : ''}>Pickup Instructions</label>
                        <textarea onChange={(e) => setPickupInstruction(e.target.value)} type="text" value={pickupInstruction} placeholder="Ask for order placed under the name of Mr A" />
                    </div>
                    <button onClick={(e) => calculateFee(e, pickupAddress, deliveryAddress)}>Calculate Fee</button>
                    <h3>Delivery Fee: $ <span>{fee}</span></h3>
                    <h3>Shopping Fee: $ <span>{upfrontFee}</span></h3>
                    <h3>Service Fee: $ <span>{surchargeFee}</span></h3>
                    <div style={prePurchaseSelected && !prePurchase ? {display: 'block'} : {display: 'none'}}>
                        <p>*There is an additional $0.45 per item charge for items that has not been purchased</p>
                    </div>
                    <div style={deliveryClass === 'extra' ? {display: 'block'} : {display: 'none'}}>
                        <p>*There is an additional $9 for orders that include multiple pickup/more than 10kg of total weight/grocery shopping</p>
                    </div>
                    <p>Please ensure that your payment is made before the due date otherwise you are subjected to a 5% weekly finance charge of the initial payment.</p>
                    <div className="input-container checkbox">
                        <input type="checkbox" onClick={() => setTermsAccepted(!termsAccepted)} />
                        <p className={(!termsAccepted && submitted) ? 'red' : ''}>By submitting you have read the <a target="_blank" href="https://uskutech.com/legal/">terms and conditions</a> of our services</p>
                    </div>
                    <input type="submit" onClick={(e) => sendOrder(e)} value="Place Order" />
                    <div className="footer">
                        &copy; Uskutechnologies 2020
                    </div>
                    <div className={loading ? 'loading-overlay show' : 'loading-overlay'}>
                        <img className="loading" src={loading_gif} alt="Usku" />
                    </div>
                </div>
            </form>
        )
    }
    else {
        return (
            <div className="form">
                <div className="form-container">
                    <img className="usku-logo" src={logo} alt="Usku" />
                    <h1>Your Order Pin is: {orderPin}</h1>
                    <h4>What happens next</h4>

                    {/* <p><b>Step 1:</b> The payer will receive a confirmation sms.</p>
                    <p><b>Step 2:</b> Once your delivery is accepted, the payer will be notified via sms..</p>
                    <p><b>Step 3:</b> An invoice will be sent to the payer's email after your delivery has been accepted.</p> */}

                    <p>
                        You will get an email for your order confirmation. Message us immediately through Facebook or contact us at usku@uskutech.com if you did not receive one within 2 minutes.
                    </p>

                    <p>
                        The usual wait time for an Usker to accept is 10 - 60 minutes from 9 am - 10 pm. 
                    </p>

                    <p>
                        We thoroughly vet Uskers before onboarding them, so we have limited uskers a day and your delivery may not always be accepted. To counter this, you can increase your delivery fee by letting us know how much you'd like to increase it by.
                    </p>

                    <p>
                        Currently, you can only cancel your delivery by contacting us with the above methods.
                    </p>

                    <p>
                        Your jobs have a higher chance of acceptance from 9 am - 10 pm, Monday - Sunday. After these hours, you may have to wait longer than 60 minutes for a job to be accepted.
                    </p>

                    <p>
                        Your delivery will automatically be cancelled once it has surpass your alloted pick up time. If you'd like to extend your  time, please email or contact us through Facebook or usku@uskutech.com. For any urgent matters, contact 0415884067.
                    </p>

                    <p>
                        Once it has been accepted, you will receive an email from us on how to access your invoice and pay.
                    </p>

                    <p>
                        In the event where an Usker cancels the delivery on the day of delivery, we want you to know that we have a strict policy that prevents this from happening. If it happens, the Usker will have their account immediately banned as we want to accomodate professional and reliable deliverers on our platform so that your experience won't be a shitty one.
                    </p>

                    <button onClick={() => setFormPage(true)}>Place Another Order</button>
                    <div className="footer">
                        &copy; Uskutechnologies 2020
                    </div>
                </div>
            </div>
        )
    }
}

export default BusinessForm;
